import React from "react";

export default function TestimonialSection() {
  return (
    <section className="py-24 bg-gray-50">
      {/* Add your testimonial content here */}
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
          What Our Students Say
        </h2>
        {/* Example testimonial card */}
        <div className="bg-white rounded-lg shadow-md p-6 flex flex-col items-center">
          <p className="text-lg text-gray-700 mb-4">
            “STEMForge transformed our classroom into a hub of innovation. The hands‑on
            robotics projects sparked curiosity and confidence in our students.”
          </p>
          <span className="text-sm text-gray-500">— Priya Sharma</span>
        </div>
      </div>
    </section>
  );
}